import { render, staticRenderFns } from "./schema-selector.vue?vue&type=template&id=b0d8ec6e&"
import script from "./schema-selector.vue?vue&type=script&lang=js&"
export * from "./schema-selector.vue?vue&type=script&lang=js&"
import style0 from "./schema-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports